// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Utils
import { getShowDueDate } from '../../../../../common/elements/utils/elementPropertyUtils';

// Components
import TaskDueDatePill from './TaskDueDatePill';

const TaskDueDatePanel = (props) => {
    const { element } = props;

    if (!getShowDueDate(element)) return null;

    return (
        <div className="TaskDueDatePanel">
            <TaskDueDatePill {...props} />
        </div>
    );
};

TaskDueDatePanel.propTypes = {
    element: PropTypes.object,
};

export default TaskDueDatePanel;
